// Also the name of the local database in browser storage and on mobile; renaming it would lose
// existing data
export const SQLITE_DB_NAME = "follow.db"

// The name of the file "Export Database" saves
export const EXPORTED_DB_FILE_NAME = "folo.db"
